import { Col } from "react-bootstrap";
import { WordContainer } from "../../components/wordcontainer";
import { skills } from "../../content_option";

export const Skill = () => {

    return (
        <>
            <Col lg={{ span: 4, offset: 1}}>
                <h3 className="color_sec py-4 ">Skills</h3>
            </Col>
            <Col lg="7">
                {skills.map((data, i) => {
                    return (
                        <div key={i} className="mb-5">
                            <h3 className="tech_title mb-3">{data.name}</h3>
                            <div className="d-flex row">
                            {
                                data.tools.map((sub,index) => <WordContainer word={sub} />)
                            }
                            </div>
                        </div>
                    );
                })}
            </Col>
        </>
    )
}